import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhoneFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M18.46 15.43c-1.08-.92-2.17-1.48-3.24-.56l-.64.56c-.47.4-1.33 2.29-4.68-1.56-3.35-3.85-1.36-4.44-.89-4.85l.64-.56c1.06-.92.66-2.09-.1-3.28l-.46-.73c-.77-1.19-1.6-1.98-2.67-1.06l-.57.5c-.47.34-1.78 1.45-2.1 3.57-.38 2.54.83 5.44 3.6 8.63 2.77 3.19 5.48 4.79 8.04 4.76a5.409 5.409 0 0 0 3.82-1.58l.58-.5c1.06-.92.4-1.86-.68-2.79l-.65-.56v.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhoneFilled
